export default __webpack_public_path__ + "static/media/ic_product_vorsorge-plus.cbc646af.svg";